module.exports = __webpack_public_path__ + "img/logo_mini.c289e5c1.jpg";